import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../services/api";
import "../components/Navbar.css";

export default function Navbar({ toggle }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 11) return "Selamat Pagi";
    if (hour >= 11 && hour < 15) return "Selamat Siang";
    if (hour >= 15 && hour < 18) return "Selamat Sore";
    return "Selamat Malam";
  };

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setName(res.data.name))
      .catch(() => handleLogout());
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  return (
    <nav className="modern-navbar">
      {/* Left */}
      <div className="nav-left">
        <button className="menu-btn" onClick={toggle}>
          ☰
        </button>

        <div className="greeting">
          <span className="greet">{getGreeting()}</span>
          {name && <span className="name">, {name}</span>}
        </div>
      </div>

      {/* Right */}
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>
    </nav>
  );
}
